export default __webpack_public_path__ + "img/jade-amulet.cfda2e33.jpg";